import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import NavigationProvider from 'components/Navigation/Provider';
import { ProgramsQuery } from 'components/Program/Form/graphql';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const ProgramForm = React.lazy(() => import('components/Program/Form/Form'));

function ScreensProgramForm(params: Readonly<RoutePrivateProps>) {
  const id = params.id ? Number(params.id) : null;
  const campaignId = params.campaignId ? Number(params.campaignId) : null;

  return (
    <BaseLayout>
      <DocumentTitle>{params.id ? 'Edit' : 'Create'} program</DocumentTitle>
      <NavigationProvider
        id={id}
        buildUrl={(newId: string) =>
          `/campaigns/${campaignId}/program/${newId}/edit`
        }
        variables={{
          f: {
            campaignId,
          },
        }}
        query={ProgramsQuery}
      >
        <Suspense fallback={<UILoader />}>
          <ProgramForm id={id} key={id} campaignId={campaignId} />
        </Suspense>
      </NavigationProvider>
    </BaseLayout>
  );
}

export default ScreensProgramForm;
